import { createContext } from 'react';

export default createContext<{
  scrollToBottom: (data?: any) => void;
  element: HTMLElement | null;
}>({
  scrollToBottom: (data?: any) => {},
  element: null,
});
